import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {IBillingOperations} from '@interfaces/billing';
import {HttpClient} from '@angular/common/http';
import {OrderType} from '../../types/order.type';
import {BillingSortType} from '../../types/billing.type';
import {createHttpParams} from '@shared/functions';
import {catchError, map, share} from 'rxjs/operators';
import {ErrorService} from '@services/error/error.service';
import {IResponse} from '@interfaces/response';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private http: HttpClient,
              private errorService: ErrorService) {
  }

  getTvOwnerOperations({limit, skip = 0, search, sort, order}:
                         {
                           limit: number, skip: number, search: string,
                           sort: BillingSortType;
                           order: OrderType;
                         }): Observable<IResponse<IBillingOperations>> {
    const params = createHttpParams({
      limit, skip, sort, order, search
    });

    return this.http.get<IResponse<IBillingOperations>>('tv-owner/billing/operations', {params})
      .pipe(
        share(),
        catchError((err) => {
          this.errorService.showError(err);
          return throwError(err);
        })
      );
  }

  getTvOwnerBalance(): Observable<number> {
    return this.http.get<{balance: number}>('tv-owner/billing/balance')
      .pipe(
        share(),
        catchError((err) => {
          this.errorService.showError(err);
          return throwError(err);
        }),
        map((res: {balance: number}) => {
          if (res.balance) return res.balance / 100;
          else return 0;
        })
      );
  }
}
